
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/ef569944f470fd3690af160caf6184e2.jpg"
          alt="Peregrinación Espiritual"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
      </div>

      {/* Logo */}
      <div className="absolute top-8 left-1/2 transform -translate-x-1/2 z-20">
        <img
          src="https://static.readdy.ai/image/55de03a58447b22c9804f3000d5f2dfc/7f3918d052d8bace5fe919afd77c8449.png"
          alt="Cuaderno de La Magdalena"
          className="h-24 w-auto"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          <h1 className="font-serif text-6xl md:text-7xl lg:text-8xl font-light text-gold-400 mb-6 leading-tight">
            Peregrinación Interior
          </h1>
          <p className="font-serif text-3xl md:text-4xl text-warm-100 mb-4">
            junto a María Magdalena
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="mt-12 mb-16"
        >
          <p className="font-sans text-xl md:text-2xl text-warm-200 mb-3">
            <strong className="text-gold-400">40 días.</strong> Una experiencia espiritual profunda.
          </p>
          <p className="font-serif text-2xl md:text-3xl text-warm-100 italic">
            Una Cuaresma que se vive desde dentro.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.9 }}
          className="flex flex-col sm:flex-row gap-6 justify-center items-center"
        >
          <Link
            to="/musica"
            className="group relative px-10 py-4 bg-transparent border-2 border-white text-white font-sans font-semibold text-lg rounded-lg hover:bg-white hover:text-dark-900 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-3 shadow-lg"
          >
            <i className="ri-music-2-line text-2xl"></i>
            Escuchar "La Magdalena"
          </Link>
          <a
            href="#cuaderno"
            className="group relative px-10 py-4 bg-gold-500 text-dark-900 font-sans font-semibold text-lg rounded-lg hover:bg-gold-400 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-3"
          >
            <i className="ri-book-open-line text-2xl"></i>
            Comprar Cuaderno
          </a>
          <a
            href="#curso"
            className="group relative px-10 py-4 bg-transparent border-2 border-gold-500 text-gold-400 font-sans font-semibold text-lg rounded-lg hover:bg-gold-500 hover:text-dark-900 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-3"
          >
            <i className="ri-computer-line text-2xl"></i>
            Inscribirme al Curso
          </a>
          <a
            href="#comunidad"
            className="group relative px-10 py-4 bg-transparent border-2 border-warm-100 text-warm-100 font-sans font-semibold text-lg rounded-lg hover:bg-warm-100 hover:text-dark-900 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-3"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Unirme a la Comunidad
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        className="absolute bottom-12 left-1/2 transform -translate-x-1/2 z-10"
      >
        <div className="flex flex-col items-center gap-2">
          <span className="font-sans text-sm text-warm-200 uppercase tracking-widest">Descubre más</span>
          <motion.i
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            className="ri-arrow-down-line text-3xl text-gold-400"
          ></motion.i>
        </div>
      </motion.div>
    </section>
  );
}
